import { connect } from "react-redux";
import ReportingMainPage from "./ReportingMainPage";
import {
  getClientsRequest,
  supportCoordinatorsRequest,
  getCosReportingFundingTableDataRequest,
} from "../../../../store/actions/ah.actions";

import {
  getClienListSelector,
  getSupportCoordinator,
  getTableDataForReportingSelector,
  tableDataForReportingLoadingSelector,
  getTableDataOfCaseNotesForReportingSelector,
  getTableDataOfCaseNotesForReportingPaginationMetaSelector,
} from "../../../../store/selector/ah.selector";
import { getSpSetting } from "../../../../store/selector/sp.selector";

const mapDispatchToProps = {
  getClientList: getClientsRequest,
  getSupportCoordinatoreList: supportCoordinatorsRequest,
  getTableDataForReporting: getCosReportingFundingTableDataRequest,
};

const mapStateToProps = (state) => {
  const clientsList = getClienListSelector(state);

  const supportCoordinator = getSupportCoordinator(state);
  const tableDataForReporting = getTableDataForReportingSelector(state);

  const tableDataForReportingLoading =
    tableDataForReportingLoadingSelector(state);

  const tableDataOfCaseNotesForReporting =
    getTableDataOfCaseNotesForReportingSelector(state);
  const caseNotesReportingPaginationMeta =
    getTableDataOfCaseNotesForReportingPaginationMetaSelector(state);
  const settings = getSpSetting(state);

  return {
    tableDataOfCaseNotesForReporting,
    caseNotesReportingPaginationMeta,
    tableDataForReportingLoading,
    tableDataForReporting,
    supportCoordinator,

    clientsList,
    settings,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportingMainPage);
